import "./Home.scss";
import { Link } from "react-router-dom";
import featureImg from "../../assets/home/home-banner.webp";
import cakeFeature from "../../assets/home/cake-feature.webp";
import cupcakeFeature from "../../assets/home/cupcake-feature.webp";
import cookieFeature from "../../assets/home/cookie-feature.webp";
import cakesicleFeature from "../../assets/home/cakesicle-feature.webp";
import googleLogo from "../../assets/home/customers/google-logo.webp";
import intuitLogo from "../../assets/home/customers/intuit-logo.webp";
import porscheLogo from "../../assets/home/customers/porsche-logo.webp";
import splunkLogo from "../../assets/home/customers/splunk-logo.webp";
import stanfordLogo from "../../assets/home/customers/stanford-logo.webp";
import courseraLogo from "../../assets/home/customers/coursera-logo.webp";
import metaLogo from "../../assets/home/customers/meta-logo.webp";
import treehouseLogo from "../../assets/home/customers/treehouse-logo.webp";
import cityMvLogo from "../../assets/home/customers/city-mv-logo.webp";
import proofpointLogo from "../../assets/home/customers/proofpoint-logo.webp";
import khanAcademyLogo from "../../assets/home/customers/khan-academy-logo.webp";
import asSjsuLogo from "../../assets/home/customers/as-sjsu-logo.webp";
import Offering from "./Offering";

type CustomerLogo = {
  src: string;
  alt: string;
  id: string;
};

const CUSTOMER_LOGOS: CustomerLogo[] = [
  { src: googleLogo, alt: "Google", id: "google" },
  { src: metaLogo, alt: "Meta", id: "meta" },
  { src: splunkLogo, alt: "Splunk", id: "splunk" },
  { src: intuitLogo, alt: "Intuit", id: "intuit" },
  { src: porscheLogo, alt: "Porsche", id: "porsche" },
  { src: stanfordLogo, alt: "Stanford", id: "stanford" },
  {
    src: asSjsuLogo,
    alt: "Associated Students of San Jose State University",
    id: "as-sjsu",
  },
  {
    src: treehouseLogo,
    alt: "Treehouse Hotel Silicon Valley",
    id: "treehouse",
  },
  { src: courseraLogo, alt: "Coursera", id: "coursera" },
  { src: cityMvLogo, alt: "City of Mountain View", id: "city-mv" },
  { src: proofpointLogo, alt: "Proofpoint", id: "proofpoint" },
  { src: khanAcademyLogo, alt: "Khan Academy", id: "khan-academy" },
];

function Home() {
  return (
    <>
      <div className="feature">
        <img
          className="feature__img"
          src={featureImg}
          alt="Mini layered cakes with fresh strawberries"
        />
        <div className="feature__text">
          <h1 className="feature__heading">
            Boutique cakes &amp; confections for every occasion
          </h1>
          <p className="feature__subheading">
            Specializing in custom designs in the San Francisco Bay Area
          </p>
          <Link to="/order">
            <button className="btn">Place an order</button>
          </Link>
        </div>
      </div>
      <div className="wrapper">
        <h2>Explore my creations</h2>
        <div className="offering-container">
          <Offering
            imgSrc={cakeFeature}
            imgAlt="Caramel drip chocolate cake"
            heading="cakes"
            desc="Elevate your event with a cake custom-made to match your theme and flavor profile."
          />
          <Offering
            imgSrc={cupcakeFeature}
            imgAlt="Pink flower cupcakes"
            heading="cupcakes"
            desc="These bite-sized delights are perfect for brightening up every gathering."
          />
        </div>
        <div className="offering-container">
          <Offering
            imgSrc={cookieFeature}
            imgAlt="Boba cookies"
            heading="cookies"
            desc="Every cookie is a masterpiece, piped with meticulous detail and irresistible in every buttery bite."
          />
          <Offering
            imgSrc={cakesicleFeature}
            imgAlt="Panda, brown bear, and polar bear cakesicles"
            heading="cakesicles"
            desc="A fun and portable treat, these hand-dipped cake popsicles make the sweetest party favor."
          />
        </div>
        <hr />
        <section className="customers">
          <h3>Featured clients &amp; partners</h3>
          <div className="customers__logos">
            {CUSTOMER_LOGOS.map(({ src, alt, id }) => (
              <img
                key={id}
                className={`customers__logo customers__logo--${id}`}
                src={src}
                alt={alt}
              />
            ))}
          </div>
        </section>
      </div>
    </>
  );
}

export default Home;
